import { render, staticRenderFns } from "./RouteIndex.vue?vue&type=template&id=7c21ba45&scoped=true&"
import script from "./RouteIndex.vue?vue&type=script&lang=js&"
export * from "./RouteIndex.vue?vue&type=script&lang=js&"
import style0 from "./RouteIndex.vue?vue&type=style&index=0&id=7c21ba45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c21ba45",
  null
  
)

export default component.exports